import { createTheme } from "@mui/material/styles"
import { defaultTheme } from "components/Theme/Style"

const theme = createTheme(defaultTheme, {
  palette: {
    mode: "light",
    primary: { main: "#154F91", dark: "#154F91" },
    secondary: { main: "#A8F1FD" },
    neutral: { main: "#2E3947" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#FF6647",
          },
        },
      },
    },
  },
})

export default theme
